module.exports = __webpack_public_path__ + "static/media/Image_Loading_Placeholder.76e74290.png";